export default {
  path: 'notes-tasks',
  name: 'subscription/notes-tasks',
  props: true,
  meta: { requiresAuth: true },
  component: () => import(/* webpackChunkName: "subscription-show-notes-tasks" */ './NotesTasks')
}
